// removed by extract-text-webpack-plugin
module.exports = {"frame":"_1ylcx0w8pQiyd0U_Rx4bBJ","tokenBalanceSummaryShorter":"_2Tpvbgp-embQCngh2LJguI"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/OasisTokenTransfer.scss
// module id = 1286
// module chunks = 0